import { LoginForm } from "@/features/Auth";

export default function LoginPage() {
  return <LoginForm />;
}
